/* eslint-disable no-shadow,consistent-return,no-param-reassign,no-unused-vars */
import jApiAutomation from '@/services/jApiAutomation';
import router from '@/router';

const state = {
  propertiesOpened: false,
  propertiesTypeBlock: null,
  propertiesDataBlock: null,
  propertiesIndexBlock: 0,
  propertiesRowBlock: 0,
  propertiesDataParentBlock: [],
  propertiesIDBlock: 0,
  pausePanZoom: null,
  resumePanZoom: null,
  dataBlockIsDisable: [],
  popoverAddBlock: null,
  dataDragBlockAction: null,
  dataDropBlockAction: null,
  dataDoAction: null,
};

const getters = {
};

const mutations = {
  changePropertiesOpened(state, data) {
    state.propertiesOpened = data;
  },

  setPropertiesOpened(state, data) {
    state.propertiesOpened = data.open || false;
    state.propertiesTypeBlock = data.type || null;
    state.propertiesDataBlock = data.data || null;
    state.propertiesIndexBlock = data.index || 0;
    state.propertiesRowBlock = data.row || 0;
    state.propertiesDataParentBlock = data.dataParent || [];
    state.propertiesIDBlock = data.idBlock || 0;
  },
  setPausePanZoom(state, data) {
    state.pausePanZoom = data;
  },
  setResumePanZoom(state, data) {
    state.resumePanZoom = data;
  },
  setDataBlockIsDisable(state, data) {
    const indexTargetBlock = state.dataBlockIsDisable.findIndex(i => i.id === data.id);

    if (indexTargetBlock !== -1) {
      state.dataBlockIsDisable[indexTargetBlock] = data;
    } else {
      state.dataBlockIsDisable.push(data);
    }
  },
  setPopoverAddBlock(state, data) {
    state.popoverAddBlock = data;
  },
  setDataDragBlockAction(state, data) {
    state.dataDragBlockAction = data;
  },
  setDataDropBlockAction(state, data) {
    state.dataDropBlockAction = data;
  },
  setDataDoAction(state, data) {
    state.dataDoAction = data;
  },
};

const actions = {
  async getListForm({ dispatch }, { reqData, callback }) {
    try {
      const resData = await jApiAutomation.getListForm(reqData);
      const res = resData.data ? resData.data : [];
      res.forEach((lab, index) => {
        res[index].label = lab.name;
      });
      callback(null, res);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async getListUser({ dispatch }, { reqData, callback }) {
    try {
      const resData = await jApiAutomation.getListUser(reqData);
      const res = resData.data ? resData.data : [];
      res.forEach((lab, index) => {
        res[index].label = lab.email;
      });
      callback(null, res);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async createAutomationCode({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait..', { root: true });
    let res;
    try {
      res = await jApiAutomation.createAutomation(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', res.message, { root: true });
    } catch (err) {
      res = err.response.data;
      // dispatch('jStoreNotificationScreen/hideLoading', {}, { root: true });
      // dispatch('jStoreNotificationScreen/toggleProblem', err.message, { root: true });
    }
    return res;
  },

  async applyAutomation({ dispatch }, params) {
    if (params.useLoading) {
      dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    }
    try {
      const create = await jApiAutomation.createAutomation(params.payload);
      if (params.useLoading) {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
      dispatch('jStoreNotificationScreen/toggleSuccess', create.message, { root: true });
      return create;
    } catch (err) {
      if (params.useLoading) {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      }
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response;
    }
  },

  async setAutomation({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const create = await jApiAutomation.createAutomation(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      // dispatch('jStoreNotificationScreen/toggleSuccess', create.message, { root: true });
      return create;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response;
    }
  },

  async createAutomation({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const create = await jApiAutomation.createAutomation(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', create.message, { root: true });
      router.push('/automation');
      return create;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response;
    }
  },

  async deleteAutomation({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const deleteAuto = await jApiAutomation.deleteAutomation(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', deleteAuto.message, { root: true });
      router.push('/visual-programming');
      return deleteAuto;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      return err.response;
    }
  },

  async getDetailAutomation({ dispatch }, data) {
    let res;
    try {
      res = await jApiAutomation.getListAutomation(data);
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async findForm({ dispatch }, data) {
    let res;
    try {
      res = await jApiAutomation.getListForm(data);
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async getCountLog({ dispatch }, data) {
    let res;
    try {
      res = await jApiAutomation.getCountLog(data);
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async getListEventNameList({ dispatch }) {
    let res;
    try {
      res = jApiAutomation.getListEventName();
    } catch (err) {
      res = err.response.data;
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async getListRunHistory({ dispatch }, data) {
    let res;
    try {
      res = await jApiAutomation.getListRunHistory(data);
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async getListActionBlock({ dispatch }, data) {
    let res;
    try {
      res = await jApiAutomation.getListActionBlock(data);
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  async getDetailActionBlock({ dispatch }, data) {
    let res;
    try {
      res = await jApiAutomation.getDetailActionBlock(data);
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  // Job Monitoring
  async getJobMonitoringList(data) {
    let res;
    try {
      res = await jApiAutomation.getJobMonitoringList(data.id, data.params);
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },

  // Dedicated Job Monitoring
  async getDedicatedJobMonitoringList(data) {
    let res;
    try {
      res = await jApiAutomation.getDedicatedJobMonitoringList(data);
    } catch (err) {
      res = err.response.data;
    }
    return res;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/stores/jStoreAutomation.js